import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";


function Profile() {
  let navigate = useNavigate();
  const { avatar, signout, firstName: authFirstName, lastName: authLastName, user } = useAuth();
  function logout() {
    signout(() => {
      navigate("/");
    })
  }
  return (
    <div className="dropdown">
      <button
        type="button"
        className="profile-space-trigger"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {avatar ? (
          <img
            alt=""
            src={`${process.env.REACT_APP_MEDIA_URL}/avatar/${avatar}`}
            className="profile-space-avatar"
          />
        ) : (
          <span className="profile-space-avatar profile-space-avatar-initial" aria-hidden="true">
            {authFirstName?.charAt(0)?.toUpperCase() || "U"}
          </span>
        )}
        <span className="profile-space-copy">
          <span className="profile-space-eyebrow">Your learning space</span>
          <span className="profile-space-name">
            {[authFirstName, authLastName].filter(Boolean).join(" ") || "My account"}
          </span>
          <span className="profile-space-role">{user?.role}</span>
        </span>
        <span className="profile-space-chevron" aria-hidden="true">
          <i className="bi bi-chevron-down"></i>
        </span>
      </button>
      <div
        className="dropdown-menu dropdown-menu-end profile-dropdown-menu"
        aria-labelledby="dropdownMenuButton1"
      >
        <div className="profile-dropdown-links">
          <Link to="/my-account" className="profile-dropdown-link">
            <i className="bi bi-person-gear" aria-hidden="true" />
            <span>My Account</span>
            <i className="bi bi-chevron-right profile-dropdown-link-arrow" aria-hidden="true" />
          </Link>
          <Link to="/dashboard" className="profile-dropdown-link">
            <i className="bi bi-grid-1x2" aria-hidden="true" />
            <span>Dashboard</span>
            <i className="bi bi-chevron-right profile-dropdown-link-arrow" aria-hidden="true" />
          </Link>
          {user?.role === "Admin" && (
            <Link to="/users" className="profile-dropdown-link">
              <i className="bi bi-people" aria-hidden="true" />
              <span>Users</span>
              <i className="bi bi-chevron-right profile-dropdown-link-arrow" aria-hidden="true" />
            </Link>
          )}
          <div className="profile-dropdown-divider" />
          <button
            type="button"
            className="profile-dropdown-link profile-dropdown-logout"
            onClick={logout}
          >
            <i className="bi bi-box-arrow-right" aria-hidden="true" />
            <span>Logout</span>
            <i className="bi bi-chevron-right profile-dropdown-link-arrow" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
export default Profile;
